import { render, staticRenderFns } from "./ZvDialog.vue?vue&type=template&id=288779b4&scoped=true&"
import script from "./ZvDialog.vue?vue&type=script&lang=js&"
export * from "./ZvDialog.vue?vue&type=script&lang=js&"
import style0 from "./ZvDialog.vue?vue&type=style&index=0&id=288779b4&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288779b4",
  null
  
)

export default component.exports